import {
  ReportType,
  reportTypeLabels,
} from '@features/campaign-list/domain/report';
import { FilterContext } from '@features/campaign-list/stores/filter-context';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { ChangeEvent, useContext } from 'react';

export const ReportTypeRadioGroup = () => {
  const { filterState, dispatch } = useContext(FilterContext);

  const isCustomDisabled = filterState.selectedCampaignType === 'cpg';

  const handleReportTypeChange = (e: ChangeEvent<HTMLInputElement>) => {
    dispatch({
      type: 'selected_report_type_changed',
      payload: e.target.value as ReportType,
    });
  };

  return (
    <RadioGroup
      value={filterState.selectedReportType}
      onChange={handleReportTypeChange}
    >
      <FormControlLabel
        value="overall"
        control={<Radio />}
        label={reportTypeLabels.overall}
      />
      <FormControlLabel
        value="custom"
        control={<Radio />}
        label={reportTypeLabels.custom}
        disabled={isCustomDisabled}
      />
    </RadioGroup>
  );
};
